/* Licensed Materials - Property of IBM IBM Cognos Products: BI Cloud (C) Copyright IBM Corp.
/* Dont modify this file. This file is auto-generated */

define([
	'./client-summaries/content-features/SummaryFeature',
	'./client-summaries/content-features/SummaryQueryResult',
	'./client-summaries/content-features/SummaryTask',
	'./client-summaries/content-features/SummaryTypes',
	'./dataBehindTheVis/content-features/DataBehindTheVis',
	'./dataBehindTheVis/content-features/api/DataBehindTheVisAPI',
	'./dataBehindTheVis/dashboard-features/DataBehindTheVisController',
	'./dataBehindTheVis/dashboard-features/DataBehindTheVisView',
	'./smarts-recommender/content-features/VisualizationSmartsRecommender',
	'./smarts-recommender/content-features/api/DeprecatedVisualizationSmartsRecommenderAPI',
	'./smarts-recommender/content-features/api/VisualizationSmartsRecommenderAPI',
	'./smarts-recommender/dashboard-features/SmartsRecommender',
	'./smarts-recommender/dashboard-features/api/DeprecatedSmartsRecommenderAPI',
	'./smarts-recommender/dashboard-features/api/SmartsRecommenderAPI',
	'./smarts-recommender/impl/FallbackRecommender',
	'./smarts-recommender/impl/SmartsRecommenderFeature',
	'./smarts-recommender/impl/Utils',
	'./smarts-recommender/impl/VisRecommenderDelegator',
	'./viprUITest/content-features/AbstractTupleLocator',
	'./viprUITest/content-features/BinarySearchTupleLocator',
	'./viprUITest/content-features/SelectorTupleLocator',
	'./viprUITest/content-features/ViprUITest',
	'./viprUITest/content-features/api/ViprUITestApi',
	'./visualization-crosstab/dashboard-features/CrosstabPropertyCallbacks',
	'./visualization-kpi/dashboard-features/KpiPropertyCallbacks',
	'./visualization-summary/dashboard-features/SummaryPropertyCallbacks'
], () => {});